import React from 'react';
import { cn } from '../../../../utils/tailwind';
import { IconClose } from '../../icons/close';
import { ModalPremiumPlusTariff } from './tariff/modal-premium-plus-tariff';
import { useEscapeClose } from '../../../../hooks/use-escape-close';
import { ModalAlerts } from '../../alerts/modal/alerts';

type ModalPremiumType = {
    children: React.ReactNode;
    show?: boolean;
    title?: string;
    footer?: React.ReactNode;
    onClose?: () => void;
    loading?: boolean;
    locked?: boolean;
    width?: number;
};

export const ModalPremiumPlus: React.FC<ModalPremiumType> = ({
    show = false,
    children,
    onClose,
    locked = false,
    width,
}: ModalPremiumType) => {
    useEscapeClose(show, onClose);

    return show ? (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center p-xsmall opacity-100 visible backdrop-blur-[0.5rem] md:p-small">
            <div
                className="relative z-[1200] max-h-full w-full overflow-auto rounded-xlarge bg-brand-primary bg-[url('/images/modals/locked-bg.png')] bg-cover bg-no-repeat px-small py-small text-neutral-white md:h-auto md:p-large lg:mt-[10rem] lg:overflow-visible lg:py-[5rem] lg:pl-[42rem] lg:pr-[5rem]"
                style={{ maxWidth: width ? `${width}rem` : '88rem' }}
            >
                <ModalAlerts />

                {children}
                <div className="mt-[7rem] flex min-h-full sm:-mx-small sm:-mb-small lg:absolute lg:left-0 lg:top-1/2 lg:mt-0 lg:w-[38rem] lg:min-w-[38rem] lg:-translate-y-1/2">
                    <ModalPremiumPlusTariff />
                </div>
                <div
                    onClick={onClose}
                    className={cn(
                        'absolute right-vsmall top-vsmall cursor-pointer opacity-40 [&_i]:h-small [&_i]:w-small [&_i]:text-[var(--modal-close-base)] hover:opacity-70 hover:[&_i]:text-[var(--modal-close-hover)]',
                        locked && 'select-none [&_i]:text-neutral-white hover:[&_i]:text-neutral-white',
                    )}
                    style={
                        {
                            '--modal-close-base': '#fff',
                            '--modal-close-hover': '#fff',
                        } as React.CSSProperties
                    }
                >
                    <IconClose />
                </div>
            </div>
            <div className="fixed inset-0 z-[1100]" style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }} />
        </div>
    ) : null;
};
